import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/rates")({
  component: lazyRouteComponent(() => import("@/pages/admin/Rates")),
});
